'use client';
import React from 'react';
import Toast from './Toast';
import { useToast } from '@/app/hooks/use-toast';
import { cn } from '@/app/lib/utils';
import Icon from './Icon';

export interface ToasterProps {
  additionalViewPortClassName?: string;
}

const Toaster: React.FC<ToasterProps> = ({ additionalViewPortClassName }) => {
  const { toasts } = useToast();

  return (
    <Toast.Provider swipeDirection="right">
      {toasts.map(({ id, title, description, action, toastType, ...props }) => (
        <Toast.Core key={id} {...props}>
          <div
            className={cn(
              'flex w-full flex-col py-2 px-4 relative',
              toastType === 'success' ? 'bg-green-50' : 'bg-red-50'
            )}
            style={{
              transform: 'translate3d(0,0,0)',
            }}
          >
            <div className="flex w-full flex-row">
              <div className="my-auto flex flex-grow">
                {title && (
                  <Toast.Title>
                    <div className="flex flex-row gap-2 items-center">
                      {toastType === 'success' ? (
                        <span className="bg-green-500 rounded-full inline-flex p-0.5">
                          <Icon name="check" className="w-3.5 h-3.5 text-white" />
                        </span>
                      ) : (
                        <span className="bg-red-500 rounded-full inline-flex">
                          <Icon name="cross-fill" className="w-4 h-4 text-white" />
                        </span>
                      )}
                      {title}
                    </div>
                  </Toast.Title>
                )}
              </div>
              <Toast.Close />
            </div>
            <div className="flex w-full flex-col">
              {description && <Toast.Description>{description}</Toast.Description>}
              {action}
            </div>
          </div>
        </Toast.Core>
      ))}
      <Toast.Viewport data-testid="toast-viewport" className={additionalViewPortClassName} />
    </Toast.Provider>
  );
};

export default Toaster;
